module.exports = __webpack_public_path__ + "static/media/Logo.f31ef195.png";